export enum UserStatus {
  unlogged = 'unlogged',
  exists = 'exists',
  logged = 'logged',
  registered = 'registered',
  verified = 'verified',
  completed = 'completed',
  associated = 'associated'
};

export interface User{
  _id: string,
  active: boolean
  apiRefreshToken: string,
  apiToken: string,
  apiTokenExpiration: number,
  createdAt: string,
  username: string,
  email: string,
  isAdmin: boolean
  modifiedAt: string,
  name: {firs: string, last: string,}
  password: string,
  phone: string,
  privacyFlags: {first: boolean}
  role: string,
  activeRoute: UserStatus,
  verificationCode: string,
  isFirstLogin: boolean,
  isVerified:boolean,
  isCongratulationVisible: boolean,
  activeGroup: {id:string, name: string},
  notificationToken: string
}





// WEBPACK FOOTER //
// ./src/app/core/data/user/user.model.ts